import http from '@/base/api/public'
import { SSL_OP_NO_QUERY_MTU } from 'constants'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')
// 検索
export const w_0002_search = (params) => {
  let querys = querystring.stringify(params)
  return http.requestGet(apiUrl.apiUrl_WorksCwSelect + '?' + querys)
}
// 更新
export const w_0002_update = (params) => {
  return http.requestPost(apiUrl.apiUrl_WorksCwSelect, params)
}
//图片取得
export const w_0002_getImage = (params) => {
  return http.requestQuickGetImage('/api/v1/files?filePath=' + encodeURIComponent(params) + '&resizeCd=0')
}
//图片更新
export const w_0002_saveImage = (formData) => {
  return http.requestPostFormData(apiUrl.apiUrl_filesUpdate, formData)
}




// WEBPACK FOOTER //
// ./src/module/api/w_0002.js